define('../src/journeys/j3-b2b/j3-b2b',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var J3_B2B = function($journey) {

        this.$journey = $journey;

        return this;
    };

    J3_B2B.prototype.init = function() {
        var _this = this;

        //this.$journey.css('min-height', );
        this.$journey.css('min-height', Math.max(this.$journey.find('.j3-b2b--disclaimer').outerHeight(true) + 54, ($(window).outerHeight(true) - $('header').outerHeight(true) - $('footer').outerHeight(true))));

       /* this.$journey.find('.m7-tabs-listitem').each(function () {
            $(this).off('click.j3').on('click.j3', function () {
                _this.$journey.find('.j3-b2b--disclaimer').fadeIn();
            });
        });*/

        $(window).on('j3.init',function(){
			//_this.init()
		})

        //display exhibitor details
        this.$journey.find('.j3-b2b--exhibitorselect').off('change.j3').on('change.j3', function () {
            var details = $(this).find('option:selected').attr('data-exhibitor'),
                $detailwrapper = _this.$journey.find('.j3-exhibitordetails--wrapper'),
                $detailwrapperItems = $detailwrapper.find('.j3-exhibitordetails--wrapper-items');

            if (details != undefined) {
                details = JSON.parse(details);

                $detailwrapperItems.html('');

                $(details).each(function () {
                    $detailwrapperItems.append('<div class="j3-exhibitordetails--item"><div class="j3-exhibitordetails--key">'+this.key+'</div><div class="j3-exhibitordetails--value">'+this.value+'</div></div>');
                });

                $detailwrapper.show();
            } else {
                $detailwrapper.hide();
            };
        });

        this.$journey.find('.mobile-dis-link').on('click',function(){
            if($(window).width() < 1025){
                var _this = this,
                thisWrapper = $(this).closest('.j3-b2b--disclaimer'),
                thisContent = $('.j3-b2b--disclaimer').html(),
                thisModal = $('.m18-modal--disclaimer'),
                thisModalTrigger = thisModal.find('.m18-modal__trigger'),
                thisModalContent = thisModal.find('.m18-modal__content');

                thisModalContent.html(thisContent);
                thisModalTrigger.trigger('click');
            }
        })

        //toggle slot state
        this.$journey.find('.j3-b2b--slot').each(function () {
           $(this).off('click.j3').on('click.j3', function () {
               _this.$journey.find('.j3-b2b--slot.selected').removeClass('selected');
               $(this).addClass('selected');
               _this.$journey.find('.j3-b2b--slotbutton').removeClass('disabled');
               _this.$journey.find('.j3-b2b--slotbutton').attr('disabled', false);
           });
        });

        //display slot value
        this.$journey.find('.j3-b2b--slotbutton').off('click.j3').on('click.j3', function () {
            var $input = $(this).closest('.form-field').find('.form-field__input--schedule'),
                time = _this.$journey.find('.j3-b2b--slot.selected').text().trim(),
                date = _this.$journey.find('.j3-b2b--slot.selected').closest('.j3-b2b--slotcolumn').find('.j3-b2b--slotdate').text().trim();

            if (!$(this).hasClass('disabled')) {
                $input.val(date + ' ' + time); 
                $input.trigger('focusout')
            };
        });

        //toggle VIP state
        this.$journey.find('.j3-b2b--vipcard').each(function () {
           $(this).off('click.j3').on('click.j3', function () {
               _this.$journey.find('.j3-b2b--slot.checked').removeClass('checked');
              _this.$journey.find('.j3-b2b--vipcard').removeClass('checked');
               $(this).addClass('checked');
               _this.$journey.find('.j3-b2b--vipbutton').removeClass('disabled');
               _this.$journey.find('.j3-b2b--vipbutton').attr('disabled', false);
           });
        });

        //display VIP value
        this.$journey.find('.j3-b2b--vipbutton').off('click.j3').on('click.j3', function () {
            var $input = $(this).closest('.form-field').find('.form-field__input--vip'),
                name = _this.$journey.find('.j3-b2b--vipcard.checked .j3-b2b--vipname').text().trim();

            if (!$(this).hasClass('disabled')) {
                $input.val(name); 
                $input.trigger('focusout')
            };
        });
    };

    return J3_B2B;
});

